import React, { FunctionComponent } from 'react'
import Svg, { Defs, G, LinearGradient, Mask, Path, Stop } from 'react-native-svg'

import { tID } from '../../utils/utils'

export interface NeurodiversityCOEToolkitIconProps {
  size?: number
}

export const NeurodiversityCOEToolkitIcon: FunctionComponent<NeurodiversityCOEToolkitIconProps> = ({ size = 63 }) => {
  return (
    <Svg testID={tID('NeurodiversityCOEToolkitIcon')} width={size} height={size} viewBox='0 0 63 63' fill='none'>
      <Path
        d='M31.7134 0C27.3659 0 23.1479 0.751154 19.1762 2.23215C9.72075 5.76345 3.07316 13.591 0.937364 23.7109C-0.474052 30.3083 -0.29358 36.4103 1.49247 42.3568C3.77264 49.9512 9.36976 56.3554 16.8488 59.9268C20.5615 61.7038 24.8269 62.7183 29.5241 62.9415C30.1278 62.9691 30.7414 62.9841 31.3513 62.9841C35.12 62.9841 38.9112 62.4637 42.6202 61.4379C42.9052 61.3664 43.1765 61.2925 43.4628 61.2072C46.7959 60.224 49.7955 58.6691 52.3619 56.5912C55.1487 54.3477 57.4425 51.5036 59.1726 48.1429C59.5136 47.4807 59.8397 46.7835 60.1994 45.9496C62.1784 41.3198 63.1343 36.1369 62.965 30.9553C62.8853 28.6643 62.5468 26.229 61.9618 23.7109C60.9985 19.6253 59.4277 15.783 57.4189 12.5928C56.8688 11.7363 56.3634 11.0165 55.8631 10.3694C52.2524 5.67692 46.6267 2.38388 39.5995 0.851476C37.0181 0.287169 34.3645 0.00125401 31.7147 0.00125401L31.7134 0Z'
        fill='url(#paint0_linear_7733_48462)'
      />
      <Mask
        id='mask0_7733_48462'
        style={{
          maskType: 'alpha',
        }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='63'
        height='63'
      >
        <Path
          d='M31.7134 0C27.3659 0 23.1479 0.751154 19.1762 2.23215C9.72075 5.76345 3.07316 13.591 0.937364 23.7109C-0.474052 30.3083 -0.29358 36.4103 1.49247 42.3568C3.77264 49.9512 9.36976 56.3554 16.8488 59.9268C20.5615 61.7038 24.8269 62.7183 29.5241 62.9415C30.1278 62.9691 30.7414 62.9841 31.3513 62.9841C35.12 62.9841 38.9112 62.4637 42.6202 61.4379C42.9052 61.3664 43.1765 61.2925 43.4628 61.2072C46.7959 60.224 49.7955 58.6691 52.3619 56.5912C55.1487 54.3477 57.4425 51.5036 59.1726 48.1429C59.5136 47.4807 59.8397 46.7835 60.1994 45.9496C62.1784 41.3198 63.1343 36.1369 62.965 30.9553C62.8853 28.6643 62.5468 26.229 61.9618 23.7109C60.9985 19.6253 59.4277 15.783 57.4189 12.5928C56.8688 11.7363 56.3634 11.0165 55.8631 10.3694C52.2524 5.67692 46.6267 2.38388 39.5995 0.851476C37.0181 0.287169 34.3645 0.00125401 31.7147 0.00125401L31.7134 0Z'
          fill='url(#paint1_linear_7733_48462)'
        />
      </Mask>
      <G mask='url(#mask0_7733_48462)'>
        <Path
          d='M171.855 49.5692C170.82 53.412 169.435 57.1799 167.622 60.7805C165.867 64.2653 163.714 67.5651 161.107 70.4812C151.03 81.7499 135.875 84.6707 121.321 83.8913C112.364 83.4116 103.779 82.1653 95.165 79.6155C86.3593 77.0096 77.3227 73.8759 67.9904 74.8097C59.65 75.6428 51.9823 79.6764 44.9637 84.2283C40.9348 86.8402 36.8742 89.8955 32.6415 92.6547C32.2422 90.408 31.2892 87.7307 29.7801 84.9702C26.894 79.6869 21.9734 74.1005 15.0195 70.6813C16.4273 62.3895 18.7209 54.6816 24.0538 46.9339C29.8119 38.5684 37.5445 31.8411 45.588 25.713C49.5509 22.6939 68.4275 12.1402 67.9103 7.74269C67.4933 4.19708 59.1694 -2.8251 56.884 -5.59254C55.891 -6.79313 50.0774 -15.7519 48.5342 -15.7016C48.5342 -15.7016 43.7397 -15.546 35.854 -15.2874C38.8179 -17.9811 40.6144 -19.4883 40.6144 -19.4883L167.62 -12.3257C167.62 -12.3257 179.607 20.7667 171.854 49.5692H171.855Z'
          fill='url(#paint2_linear_7733_48462)'
          fillOpacity='0.49'
        />
      </G>
      <Path
        d='M27.5022 28.2104C28.8237 28.2582 30.0386 28.3918 31.1542 28.5978C31.2473 28.5536 31.3405 28.5107 31.4386 28.4727C32.8974 27.8978 34.6382 27.2051 36.3066 26.537C35.1923 25.647 33.9921 24.5584 33.2762 22.9623C31.8774 19.8423 34.8907 16.9884 40.6488 18.3762C38.3968 15.1974 33.5349 12.4624 23.0411 15.7454C4.18792 21.6456 10.2831 35.9446 18.6548 37.1975C17.5258 33.1973 19.3585 27.9161 27.5022 28.2104Z'
        fill='#A3C979'
      />
      <Path
        d='M35.6373 37.9202C36.1938 34.5796 37.3413 33.0766 38.1516 31.6938C36.4782 30.2681 34.187 29.1611 31.1541 28.5996C27.1405 30.5255 27.7007 37.9067 19.2359 37.2655C19.0409 37.2508 18.8473 37.2288 18.6548 37.1993C19.036 38.5478 19.7532 39.7517 20.68 40.5448C24.354 43.6942 31.1762 41.3319 33.0138 46.0553C34.8514 50.7787 37.9996 51.4345 37.9996 51.4345C40.8866 50.9969 41.6148 48.7523 41.8195 45.6323C41.3867 45.5772 40.9442 45.5012 40.4931 45.3994C35.245 44.2189 35.6385 37.9202 35.6385 37.9202H35.6373Z'
        fill='#F69170'
      />
      <Path
        d='M31.1558 28.5984C30.0402 28.3912 28.8254 28.2588 27.5038 28.211C19.3601 27.9168 17.5274 33.1992 18.6565 37.1981C18.8489 37.2275 19.0426 37.2496 19.2376 37.2643C27.7024 37.9054 27.141 30.5255 31.1558 28.5984Z'
        fill='#4D9116'
      />
      <Path
        d='M44.8215 19.9442C43.31 19.1878 41.9137 18.6803 40.6486 18.375C41.009 18.8825 41.302 19.4023 41.541 19.9098C42.5132 21.9755 41.5459 24.4334 39.4276 25.2854C38.4885 25.663 37.4134 26.0945 36.3052 26.5371C37.8461 27.7691 39.2204 28.6211 38.9164 29.9157C38.7631 30.5679 38.4848 31.1207 38.1502 31.692C40.9317 34.0629 42.0056 37.3165 41.9345 40.4119C41.8904 42.2924 41.9198 44.0712 41.8181 45.6306C46.4238 46.2129 49.9765 44.1484 51.7749 39.2313C53.7425 33.8521 53.2178 24.1429 44.8215 19.9442Z'
        fill='#85CCD5'
      />
      <Path
        d='M33.2754 22.9633C33.9913 24.5594 35.1915 25.648 36.3059 26.538C37.4128 26.0954 38.4892 25.6639 39.4282 25.2863C41.5466 24.4356 42.5138 21.9764 41.5417 19.9108C41.3026 19.4032 41.0084 18.8834 40.6492 18.3759C34.8899 16.9882 31.8779 19.8421 33.2766 22.962L33.2754 22.9633Z'
        fill='#3BA5B5'
      />
      <Path
        d='M38.1526 31.6934C37.3423 33.0762 36.1961 34.5791 35.6383 37.9197C35.6383 37.9197 35.2448 44.2172 40.4929 45.399C40.944 45.5007 41.3866 45.5767 41.8193 45.6319C41.921 44.0726 41.8929 42.2938 41.9358 40.4132C42.0081 37.3178 40.9342 34.0643 38.1514 31.6934H38.1526Z'
        fill='#F47352'
      />
      <Path
        d='M17.0474 8.0293C17.0474 8.0293 17.0474 16.3568 15.8503 17.3489C14.6531 18.341 8.06543 18.1423 8.06543 18.1423C8.06543 18.1423 15.6502 18.341 16.0504 19.5302C16.4488 20.7193 17.0491 28.1785 17.0491 28.1785C17.0491 28.1785 16.849 20.1248 17.6477 19.5302C18.4464 18.9356 25.5484 18.1039 25.5484 18.1039C25.5484 18.1039 18.2463 18.1423 17.6477 17.3489C17.0491 16.5556 17.0491 8.0293 17.0491 8.0293H17.0474Z'
        fill='white'
      />
      <Path
        d='M43.8119 15.4093C44.7852 15.4093 45.5742 14.6434 45.5742 13.6988C45.5742 12.7541 44.7852 11.9883 43.8119 11.9883C42.8386 11.9883 42.0496 12.7541 42.0496 13.6988C42.0496 14.6434 42.8386 15.4093 43.8119 15.4093Z'
        fill='white'
      />
      <Path
        d='M24.4631 54.877C25.1272 54.877 25.6655 54.3423 25.6655 53.6827C25.6655 53.023 25.1272 52.4883 24.4631 52.4883C23.7991 52.4883 23.2607 53.023 23.2607 53.6827C23.2607 54.3423 23.7991 54.877 24.4631 54.877Z'
        fill='white'
      />
      <Path
        d='M51.7509 13.9296C52.1125 13.9296 52.4057 13.6385 52.4057 13.2793C52.4057 12.9201 52.1125 12.6289 51.7509 12.6289C51.3893 12.6289 51.0962 12.9201 51.0962 13.2793C51.0962 13.6385 51.3893 13.9296 51.7509 13.9296Z'
        fill='white'
      />
      <Defs>
        <LinearGradient
          id='paint0_linear_7733_48462'
          x1='30.7214'
          y1='-22.0781'
          x2='31.4921'
          y2='62.9841'
          gradientUnits='userSpaceOnUse'
        >
          <Stop stopColor='#F0F7EA' />
          <Stop offset='1' stopColor='#BCD89D' />
        </LinearGradient>
        <LinearGradient
          id='paint1_linear_7733_48462'
          x1='31.4921'
          y1='0'
          x2='31.4921'
          y2='62.9841'
          gradientUnits='userSpaceOnUse'
        >
          <Stop stopColor='#F0F7EA' />
          <Stop offset='1' stopColor='#BCD89D' />
        </LinearGradient>
        <LinearGradient
          id='paint2_linear_7733_48462'
          x1='51.6698'
          y1='1.5325'
          x2='15.1668'
          y2='96.7434'
          gradientUnits='userSpaceOnUse'
        >
          <Stop stopColor='#C1DB97' />
          <Stop offset='0.8' stopColor='white' />
        </LinearGradient>
      </Defs>
    </Svg>
  )
}
